import React from 'react';
import { useHistory } from 'react-router-dom';
import { MapPinIcon } from '@heroicons/react/24/outline';
import UserRatingDisplay from '../../../components/common/UserRatingDisplay';
import UserProfilePic from '../../../components/common/UserProfilePic';

const MerchantInfo = ({ 
  merchant,
  onMessageMerchant,
  className = ''
}) => {
  const history = useHistory();
  
  if (!merchant) return null;

  const hasProfilePic = merchant.profilePic?.[0]?.url;
  
  let merchantLocation = null;
  if (merchant.defaultAddress) {
    merchantLocation = merchant.defaultAddress;
  } else if (merchant.addresses && merchant.addresses.length > 0) {
    merchantLocation = merchant.addresses.find(addr => addr.isDefault) || merchant.addresses[0];
  }
  
  const handleProfileClick = () => {
    history.push(`/merchant/${merchant.id}`);
  };

  return (
    <div className={`border-t border-gray-200 pt-6 ${className}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div 
            className="cursor-pointer"
            onClick={handleProfileClick}
          >
            <UserProfilePic 
              user={merchant} 
              className="h-12 w-12"
              altText={merchant.username || "Merchant"}
            />
          </div>
          <div>
            <h3 
              className="text-sm font-medium text-gray-900 cursor-pointer hover:text-brand-teal"
              onClick={handleProfileClick}
            >
              {merchant.username}
            </h3>
            {merchantLocation && merchantLocation.city && merchantLocation.country && (
              <div className="mt-1 flex items-center text-xs text-gray-500">
                <MapPinIcon className="h-3 w-3 mr-1 text-brand-teal flex-shrink-0" />
                <span>{merchantLocation.city}, {merchantLocation.country}</span>
              </div>
            )}
            <UserRatingDisplay userId={merchant?.id} ratingComponentSize="sm" className="mt-1" />
          </div>
        </div>
        <button
          onClick={onMessageMerchant}
          className="ml-4 inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-teal"
        >
          Message
        </button>
      </div>
    </div>
  );
};

export default MerchantInfo; 